import { render, staticRenderFns } from "./CustomerLog.vue?vue&type=template&id=c2088028&scoped=true&"
import script from "./CustomerLog.vue?vue&type=script&lang=js&"
export * from "./CustomerLog.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLog.vue?vue&type=style&index=0&id=c2088028&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2088028",
  null
  
)

export default component.exports